var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes, attrs: { id: "app" } },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in", appear: "" } },
        [
          _c(
            _vm.layoutComponent,
            _vm._b(
              {
                key: _vm.layout,
                tag: "component",
                staticClass: "body-wrap wrapper",
              },
              "component",
              {
                noHeader: _vm.noHeader,
                noFooter: _vm.noFooter,
                noScroll: _vm.noScroll,
              },
              false
            ),
            [_c("router-view")],
            1
          ),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isMainLoading
            ? _c("d-loading", {
                attrs: { "spinner-size": 96, "spinner-thickness": "12px" },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }